import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-706ad832"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "view-records-loading"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "view-records-text" }
const _hoisted_4 = { class: "text-opacity" }
const _hoisted_5 = { class: "text-opacity" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_top_box = _resolveComponent("top-box")!
  const _component_loading = _resolveComponent("loading")!
  const _component_list = _resolveComponent("list")!
  const _component_bg_slot = _resolveComponent("bg-slot")!
  const _component_layout = _resolveComponent("layout")!

  return (_openBlock(), _createBlock(_component_layout, { class: "view-records" }, {
    other: _withCtx(() => [
      _createVNode(_component_bg_slot, {
        skinImage: _ctx.query.skin
      }, {
        default: _withCtx(() => [
          _createVNode(_component_top_box, {
            skinImage: _ctx.query.skin,
            redPackBasicInfo: _ctx.redPackBasicInfo
          }, null, 8, ["skinImage", "redPackBasicInfo"]),
          (!_ctx.redPackBasicInfo.sender)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_loading, { theme: "dark" })
              ]))
            : _createCommentVNode("", true),
          _createVNode(_Transition, { name: "received-list" }, {
            default: _withCtx(() => [
              (_ctx.redPackBasicInfo.sender)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$checkI18n("receive.opened", {
                    number: `${_ctx.redPackBasicInfo.receivedCount}/${_ctx.redPackBasicInfo.count}`,
                  })), 1),
                      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$checkI18n("receive.total", {
                    number: `${_ctx.$tools.amountFormat(
                      _ctx.redPackBasicInfo.amount,
                      _ctx.redPackBasicInfo.decimal
                    )} ${_ctx.redPackBasicInfo.denom}`,
                  })), 1)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.redPackBasicInfo.receivedList, (received, index) => {
                      return (_openBlock(), _createBlock(_component_list, {
                        key: index,
                        receiver: received
                      }, null, 8, ["receiver"]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["skinImage"])
    ]),
    _: 1
  }))
}